(ns teamoesterreich.admin-mode.administration.help.help-page
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.webHelpText :as d-webHelpText]
            [reagent-material-ui.icons.help :refer [help]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            ))


(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))



(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))

(defn get-it [page]
  (let [!webHelpText-elem (r/atom {:loaded false :data {} :opened nil})]
    (fn []
      (let [!loaded (r/cursor !webHelpText-elem [:loaded])
            !data (r/cursor !webHelpText-elem [:data])]
        (when-not @!loaded
          (do
            (d-webHelpText/get-entry-by-page page
                                             (fn [response]
                                               (swap! !webHelpText-elem assoc :loaded true :data response)))
            [mui/paper
             [:br]
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [mui/typography {} "Lade Hilfetext ... " page]
             ]
            ))

        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style      {:textAlign "left" :margin "10px 0 50px 0"}
          }

         [mui/grid
          {:container false
           :item      true
           :xs        12
           }

          [mui/card


           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (a/set-help false))
                         }
             "Zurück"
             ]
            ]
           [mui/card-header
            {:title (r/as-element [:span (str (or (:webHelpText-title @!data) page)) "  "  [help {:height "20px"}]])}]

           [mui/card-content

            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (:webHelpText-longContent @!data) "Leider keine Hilfe verfügbar"))}
                   :className               "editor-preview-widget"
                   :style                   {:margin-left "5px" :display "inline-block" :vertical-align "top" :minHeight "200px" :padding "10px"}}]

            ]






           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (a/set-help false))
                         }
             "Zurück"
             ]
            ]
           ]]

         ])
      )
    ))

